




















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Comment extends Vue {
  @Prop({ default: '' }) public value: string;
  @Prop({ default: null }) public label: string;
  @Prop({ default: null }) public placeholder: string;
  @Prop({ default: false }) public readonly isCommentRequired!: boolean;
  @Prop({ default: false }) public readonly showRequiredFieldWarning!: boolean;

  public get labelForm(): string {
    return !this.label ? this.$tc('howCouldWeImprove') : this.label;
  }

  public get placeholderForm(): string {
    return !this.placeholder ? this.$tc('leaveYourSuggestionHere') : this.placeholder;
  }
}
